import script from "./MenuWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuWrapper.vue?vue&type=script&setup=true&lang=js"

import "./MenuWrapper.vue?vue&type=style&index=0&id=eee9b77e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eee9b77e"]])

export default __exports__